import { InjectionToken } from '@angular/core';
import { AdminDashboardReportsPort } from './admin-dashboard-reports.port';

export const ADMIN_DASHBOARD_REPORTS_PORT = new InjectionToken<AdminDashboardReportsPort>('ADMIN_DASHBOARD_REPORTS_PORT');
